<template>
  <su-page>
    <div class="mt30" slot="content">
      <div v-html="details.content"></div>
    </div>
  </su-page>
</template>
<script>

import {cateDetail} from "@/api/api";

export default {
  name: "outline",
  data() {
    return {
      id: '12',
      details: {},
    }
  },
  created() {
    this.cateDetail()
  },
  mounted() {

  },
  methods: {
    cateDetail() {
      cateDetail({id: this.id}).then(res => {
        if (res.status === 200) {
          this.details = res.data
        }
      })
    }
  }
}
</script>


<style scoped lang="scss">

</style>
